import { render, staticRenderFns } from "./description_edition.vue?vue&type=template&id=97c824e2&scoped=true&"
import script from "./description_edition.vue?vue&type=script&lang=js&"
export * from "./description_edition.vue?vue&type=script&lang=js&"
import style0 from "./description_edition.vue?vue&type=style&index=0&id=97c824e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c824e2",
  null
  
)

/* custom blocks */
import block0 from "./description_edition.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports